import React, { useRef } from 'react'
import { Grid, Typography } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

import useTranslate from '../../../../../i18n/useTranslate'
import useSignRepresent from './useSignVicePresident'
import { ButtonSign } from '../pageAction'
import Dialog from '../../../../../control/dialog/dialog'
import MyAccordion from '../../../../../control/accordion/accordion'
// import Checkbox from '../../../../../control/checkbox/checkbox'
import MyRadio from '../../../../../control/radio/radio'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import constSubmittedStatus from '../../../../../constants/submittedStatus'
import constSubmittedStep from '../../../../../constants/submittedStep'

// type ErrorsType = {
//     chairmanSign?: string
//     secretarySign?: string
// }
export type SignRepresentREC1ViewType = ReturnType<typeof useSignRepresent>
const SignRepresentREC1View = (props: SignRepresentREC1ViewType) => {
    const {
        onRefDialog,
        configDialog,
        isViewMode,
        initialValues,
        groupsUserLut,
        handleDirtyChange,
        onSubmitForm,
        initialUploadFileCer,
        certificateTopicList,
        projectData,
    } = props

    const translate = useTranslate()
    // const isFirstTime = useRef<boolean>(true)

    //มีการลงนามไปแล้ว
    const isSigning: boolean =
        projectData?.stepID === constSubmittedStep.sign &&
        projectData?.submittedStatusInfo?.value === constSubmittedStatus.complete

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{
                ...initialValues,
                uploadFile: initialUploadFileCer,
            }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(props) => {
                return (
                    <React.Fragment>
                        <Grid container spacing={2} justify={'flex-end'}>
                            <Grid item xs={12} md={12} lg={12}>
                                <MyAccordion title={translate.get('LABEL.SIGNED_SUBSTITUTION')}>
                                    {groupsUserLut && groupsUserLut?.length > 0 ? (
                                        <MyRadio
                                            name="userGroupsSign"
                                            options={groupsUserLut ?? []}
                                            // labelGroup={translate.get('LABEL.NEED_EDIT_FORM')}
                                            // tooltipLabel={translate.get('LABEL.NEED_EDIT_FORM_INFO')}
                                            onChangeValue={() => {}}
                                            requiredHalfWidth={true}
                                            disabled={isViewMode}
                                            required
                                        />
                                    ) : (
                                        <Typography style={{ color: '#bdbdbd' }}>
                                            {translate.get('LABEL.ALREADY_SIGNED')}
                                        </Typography>
                                    )}
                                </MyAccordion>
                            </Grid>

                            {isSigning && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <UploadDoc
                                        initialData={initialUploadFileCer}
                                        documentTitleList={certificateTopicList}
                                        title={translate.get('LABEL.CERTIFICATE_SIGN')}
                                        isViewMode={true}
                                        disabledBtn={true}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {!isViewMode && (
                            <ButtonSign
                                onClickSave={() => {
                                    props.form.change('saveType', 'SAVE')
                                    props.handleSubmit()
                                }}
                            />
                        )}
                        <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}
export type SignRepresentREC1Type = { callbackSaveComplete?: (status: number, isDraft: boolean) => void }
const SignRepresentREC1 = (props: SignRepresentREC1Type) => {
    const signRepresent = useSignRepresent(props)
    return <SignRepresentREC1View {...signRepresent} />
}

export default SignRepresentREC1
